import React from 'react'
import './Login.scss';
import loginImage from '../../../assets/loginImage.jpg'
import logo from '../../../assets/logo-login.svg'
import { Form, Input, Checkbox } from 'antd';
import Button from '../../Atoms/Button/Button';
import { useLocation } from 'wouter';

const Login = () => {
  const [, setLocation ] = useLocation();

  const onFinish = (values) => {
    console.log('login:', values);
    setLocation('/dashboard')
  };

  return (
    <div className="login">
      <div className="nd-grid login__grid s-grid-1 m-grid-5">
          <div className="login__img m-cols-2">
            <img src={loginImage} alt="Login Fondo Persona" />
            <div className="login__logo">
              <img src={logo} alt="Logo Geniux" />
            </div>
          </div>
          <div className="login__form m-cols-3 ">
            <div>
              <h1 className="poppins-40 mb-20">Login</h1>
              <p className="source-20  mb-20">Introduce tus credenciales para acceder al dashboard Geniux.</p>
              <Form onFinish={onFinish} >

                <p className="source-16 mb-10">Usuario:</p>
                <Form.Item name="username" rules={[{ required: true, message: 'Ingrese su Usuario!' }]} >
                  <Input size="large" />
                </Form.Item>

                <p className="source-16 mb-10">Contraseña:</p>
                <Form.Item name="password" rules={[{ required: true, message: 'Ingrese su Contraseña!' }]} >
                  <Input.Password size="large" />
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit" customClass="s-large" content="Ingresar"/>
                </Form.Item>

                <Form.Item name="remember" valuePropName="checked" className="text-center">
                  <Checkbox className="c-dark center source-16 bold">Mantener login</Checkbox>
                </Form.Item>

                <p className="source-16 mb-15 login__recoverPass text-center">¿Has perdido tu contraseña? <span>Recupérala aquí</span></p>

              </Form>
            </div>
          </div>
      </div>
    </div>
  )
}

export default Login
